import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { displayMode } from 'common/forms/displayMode';

import Button from 'components/Common/Buttons';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import { addOnlineForm, showFormChoiceModal, addFormGroup } from 'actions/form';

function isNullOrWhitespace(input) {
  return !input || input.trim() === '';
}

class FormSelectionCard extends React.Component {
  onAddForm() {
    const { dispatch, formType, formDisplayMode, selectedAccountId, formGroup, singleFormJourney, availableOnlineForms } = this.props;
    const maxMobileWidth = 992;

    const formTypeInfo = availableOnlineForms.find(ft => ft.formType === formType);

    if (formGroup) {
      dispatch(addFormGroup(formGroup.formTypes, selectedAccountId, formGroup.key));
    } else if (singleFormJourney || (formDisplayMode === displayMode.Stacked || window.innerWidth <= maxMobileWidth)) {
      dispatch(showFormChoiceModal(formType));
    } else {
      dispatch(addOnlineForm(formTypeInfo, selectedAccountId));
    }
  }

  render() {
    const { title, introductionMessageId, isEnabled, isAddingForm, formType, selectedAccountId, intl } = this.props;
    return (
      <div className="card">
        <h2>{ title }</h2>
        <p>{ !isNullOrWhitespace(introductionMessageId) && <LocalisedMessage id={ introductionMessageId } /> }</p>
        <Button
          id={ `${ title.toLowerCase() }-start-button` }
          value={ intl.formatMessage({ id: 'formSelection.startForm.buttonText' }) }
          className={ `btn-primary${ isAddingForm === formType ? ' btn-active' : '' }` }
          disabled={ selectedAccountId === 0 }
          onClick={ () => isEnabled && this.onAddForm() }
        />
      </div>
    );
  }
}

FormSelectionCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
  introductionMessageId: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool,
  isAddingForm: PropTypes.string,
  formDisplayMode: PropTypes.number.isRequired,
  selectedAccountId: PropTypes.number,
  formGroup: PropTypes.shape({
    key: PropTypes.string,
    formTypes: PropTypes.arrayOf(PropTypes.string)
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  singleFormJourney: PropTypes.bool,
  availableOnlineForms: PropTypes.arrayOf(PropTypes.shape),
};

FormSelectionCard.defaultProps = {
  isEnabled: false,
  isAddingForm: null,
  selectedAccountId: 0,
  formGroup: null,
  singleFormJourney: false,
  availableOnlineForms: [],
};

function mapStateToProps(state) {
  const {
    form: {
      isAddingForm,
      selectedAccountId
    },
    app: {
      onlineConfig
    }
  } = state;

  const activeFormTypes = onlineConfig?.formTypes?.filter(x => x.isEnabled && x.isVisible) ?? [];
  const activeFormGroups = onlineConfig?.formGroups?.filter(x => x.isEnabled && x.isVisible) ?? [];

  const availableOnlineForms = [...activeFormTypes, ...activeFormGroups];

  return {
    isAddingForm,
    formDisplayMode: onlineConfig ? onlineConfig.formDisplayMode : displayMode.Irs,
    singleFormJourney: (activeFormTypes?.length === 1 && (!activeFormGroups?.length)),
    selectedAccountId,
    availableOnlineForms
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(FormSelectionCard));
